<template>
  <div>
    <div class="card">
      <div class="card card-custom" >
        <div class="card-header flex-wrap border-0 pt-6 pb-0">
          <div class="card-title">
            <h3 class="card-label">{{ $t('setting.tag_list') }}</h3>
          </div>
          <div class="card-toolbar">
            <div class="d-flex justify-content-end align-items-center">
              <div>
                <Button v-if="$can(abilities.CREATE_TAG)" btn-class="btn-sm" type="new" btn-text="tag.new_tag" @click="openCreateModal"/>
              </div>
            </div>
          </div>
        </div>

        <div class="card-body" >
          <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="kt_datatable_tag" style="margin-top: 13px !important; cursor:pointer">
            <thead>
            <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
              <th> {{$t("name")}}</th>
              <th>{{$t("actions")}}</th>
            </tr>
            </thead>
          </table>
        </div>
      </div>
    </div>

    <Create
        id="create_tag"
        @reloadDatatable="reloadDatatable"
    />

    <Update
        id="update_tag"
        :editForm="editForm"
        @reloadDatatable="reloadDatatable"
    />
  
  </div>
</template>

<script setup>
  import Create from '@/Modules/CRM/components/Tag/Create.vue';
  import Update from '@/Modules/CRM/components/Tag/Update.vue';
  import {BASE_URL} from "@/services/api";
  import { useRouter } from "vue-router"
  import Ls from "@/services/ls";
  import { useI18n } from 'vue-i18n'
  import {useStore} from "vuex";
  import {nextTick, onMounted, ref, watch} from "vue"
  import {useHasAbility} from "@/composables/hasAbility";
  import { useLocales } from '@/composables/locales';
  import Button from "@/components/Button.vue"
  import {useSwal} from "@/composables/useSwal";
  import {Theme} from "@/composables/theming";
  import abilities from "@/composables/abilities";

const {showSwal} = useSwal()
  const { t } = useI18n({ useScope: 'global' })
  const { can } = useHasAbility()
  
  const table = ref(null)
  
  const {locale, datatableLocaleUrl} = useLocales()
  
  const editForm = ref({
    name:"",
    id:""
  })
  
  const router = useRouter()
  
  const store = useStore()
  
  onMounted(() => {
    fetchPayment('kt_datatable_tag')
  })
  
  watch(() => locale.value, () => {
    nextTick(() =>  fetchPayment('kt_datatable_tag') )
  })
  
  function openCreateModal(){
    $('#kt_modal_create_tag').modal('toggle')
  }
  
  $(document).on("click", "#kt_datatable_tag .delete_btn", (e) => {
    deletePayment(e.target.getAttribute('data-id'))
  });
  
  function fetchPayment(tableId){
    const AUTH_TOKEN = Ls.get('auth.token')
    const pageLimit = Ls.get('pageLength')

    table.value = $("#" + tableId).DataTable({
      destroy: true,
      responsive: !0,
      searchDelay: 500,
      processing: !0,
      serverSide: !0,
      pageLength: pageLimit ||  5,
      lengthMenu: [5, 10, 25, 50, 75, 100 ],
      order: [[ 0, 'asc']],
      ajax: {
        url: BASE_URL + "/get/tags/datatables",
        type: "GET",
        beforeSend: function (request, options) {
          request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
          request.setRequestHeader("Company", Ls.get('current.company'));
        }
      },
      columns: [{ data: "name" }, { data: "Actions", responsivePriority: -1 }],
      columnDefs: [
  
        {
          targets: -2,
          order: "desc",
          render: function (t, a, e, l) {
            return '<span>' + t + "</span>";
          },
        },
        {
          width: "15%",
          targets: -1,
          "className": "dt-center",
          title: "Actions",
          orderable: !1,
          render: (t, a, e, l) => {
            let render=""
  
            if(can(abilities.UPDATE_TAG)) {
              render += '<a href="javascript:;" data-row="'+ l.row +'" data-id="'+ e.id +'" data-name="'+ e.name +'"  class="btn btn-sm btn-clean btn-icon edit_btn" ><i data-row="'+ l.row +'" data-id="'+ e.id +'" data-name="'+ e.name +'"  class="fas fa-edit fs-2"  style="color: '+Theme.gray +'" data-toggle="tooltip" data-placement="top" title="'+i18n.global.t('button.edit')+'" ></i></a>'
            }

            if (can(abilities.DELETE_TAG)) {
              render += '<a href="javascript:;"  data-id="'+ e.id +'" class="btn btn-sm btn-clean btn-icon delete_btn"><i  data-id="'+ e.id +'" class="fas fa-trash fs-2" style="color: '+Theme.gray +'"  data-toggle="tooltip" data-placement="top" title="'+i18n.global.t('button.delete')+'" ></i></a>'
            }
  
            return render
          },
        },
      ],
      language: {
        url:  datatableLocaleUrl.value
      }
    });
  
  }
  
  $(document).on("click", "#kt_datatable_tag .edit_btn", (e) => {
    editForm.value.id = e.target.getAttribute('data-id')
    editForm.value.name = e.target.getAttribute('data-name')

    $('#kt_modal_update_tag').modal('toggle')
  
  });
  
  
  $(document).on("click", "#kt_datatable_tag .users_btn", (e) => {
    router.push({
      name: 'settings-department-users',
      params: { id: e.target.getAttribute('data-id') }
    })
  
  });
  
  
  function reloadDatatable() {
    fetchPayment('kt_datatable_tag')
  }
  
  async function deletePayment(id){
    showSwal(
        '',
        i18n.global.t('swal.tag_deleting')
    ).then( async (result) => {
        if (result.value) {
          try {
            await store.dispatch('tags/deleteTag', id)
            reloadDatatable()
            window.toastr.success(t('notification.tag_deleted'))
          }catch (e) {
          }
        }
    })
  }
  
  </script>
  